import { Box, Heading, Stack, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ErrorLayoutProps {
  icon: ReactNode;
  code?: string;
  title: string;
  description: string;
  children: ReactNode;
  accentColor: string;
}

export function ErrorLayout({
  icon,
  code,
  title,
  description,
  children,
  accentColor,
}: ErrorLayoutProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      w="full"
      px={6}
      py={12}
    >
      <Stack gap={0} textAlign="center" maxW="lg" align="center">
        <Box
          w="80px"
          h="80px"
          borderRadius="full"
          bg={`${accentColor}/8`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={5}
        >
          {icon}
        </Box>

        {code && (
          <Box
            mb={3}
            px={3}
            py={1}
            borderRadius="full"
            bg="gray.100"
            display="inline-flex"
            alignSelf="center"
          >
            <Text
              fontSize="xs"
              fontWeight="600"
              color="gray.500"
              letterSpacing="wider"
              textTransform="uppercase"
            >
              {code}
            </Text>
          </Box>
        )}

        <Heading size="xl" fontWeight="600" mb={2}>
          {title}
        </Heading>
        <Text color="gray.500" fontSize="md" maxW="sm" lineHeight="tall" mb={8}>
          {description}
        </Text>

        {children}
      </Stack>
    </Box>
  );
}
